import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost } from "../../Services/ApiService";

export const getCityStateDistrictByPinCode = (pinCode, callBack) => {
  return async () => {
    try {
      const response = await apiGet(
        `${ApiConstants.getCityStateDistrictByPinCodeUrl}?pincode=${pinCode}`
      );
      callBack && callBack(response, response?.data);
    } catch (error) {
      console.log("get city state district by pincode api err:", error);
      throw error;
    }
  };
};

export const getUserAddidtionalQuestionsAPI = (params, callBack) => {
  return async () => {
    try {
      const response = await apiGet(
        ApiConstants.getUserAddidtionalQuestionsUrl,
        params
      );
      callBack && callBack(response, response?.data);
    } catch (error) {
      console.log("get user additional questions api err:", error);
      throw error;
    }
  };
};

export const addUserAddidtionalQuestionsAPI = (data, callBack) => {
  return async () => {
    try {
      const response = await apiPost(
        ApiConstants.addUserAddidtionalInfoUrl,
        data
      );
      callBack && callBack(response, response?.data);
    } catch (error) {
      console.log("add user additional questions api err:", error);
      throw error;
    }
  };
};
export const getUserDetailsInOnboarding = (params, callBack) => {
  return async () => {
    try {
      const response = await apiGet(
        ApiConstants.getUserDetailsInOnboardingUrl,
        params
      );
     
      callBack && callBack(response, response?.data);
    } catch (error) {
      console.log("get user details in onboarding api err:", error);
      throw error;
    }
  };
};
